<template>
  	<DnsBatchList />
</template>

<script>

// @ is an alias to /src
import DnsBatchList from "../components/DnsBatchList.vue";

export default {
  name: "PinBatchLists",
  components: {
    DnsBatchList,
  },
};
</script>
